export { Table } from './table';
export { TableRow } from './table-row';
export { TableCell } from './table-cell';
export { TableHeadCell } from './table-head-cell';

export type { TableTotalProps, TableCellType } from './table';
